<template>
    <div class="withdrawncash">
        <div class="search">
            <div class="choose-box">
                <img src="../../../assets/image/nsale/time_icon.png" alt="" class="date_icon">
                <p class="choose-date">时间选择</p>
            </div>
            <p class="date" @click="showDatePicker">
                <input type="text" v-model="date">
                <img src="../../../assets/image/nsale/down.png" alt="">
            </p>
        </div>
        <div class="card_box" v-for="(item, index) in recordList" :key="index">
            <h3 v-if="item.list.length">{{item.year}}</h3>
            <ul v-if="item.list.length">
                <li v-for="(ele, ind) in item.list" :key="ind">
                    <p class="withdraw_date">提现日期：{{ele.withdrawDate}}</p>
                    <div class="flex">
                        <p class="detail" @click="goPage(ele)">
                            <span>查看明细</span>
                            <span class="icon"></span>
                        </p>
                        <p>
                            <span class="money">￥</span>
                            <span class="red">{{ele.actualAmount || '0.00'}}</span>
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import api from '@/utils/api'
export default {
  data () {
    return {
      datePicker: null,
      dateText: '', // 展示用
      dateValue: '', // 传值用
      recordList: []
    }
  },
  created () {
    let data = new Date()
    this.date = `${data.getFullYear()}年${data.getMonth() + 1}月`
    this.dateValue = `${data.getFullYear()}-${data.getMonth() + 1}`
    this.fetchData()
  },
  methods: {
    // 打开新页面
    goPage (item) {
      this.$router.push({
        path: '/bs/withdrawdetail',
        query: {
          name: item.name,
          userId: this.$route.query.userId
        }
      })
    },
    // 打开时间选择器
    showDatePicker () {
      if (!this.datePicker) {
        this.datePicker = this.$createDatePicker({
          title: '选择时间',
          startColumn: 'year',
          columnCount: 2,
          min: new Date(1970, 1, 1),
          max: new Date(),
          value: new Date(),
          onSelect: this.selectHandle
        })
      }
      this.datePicker.show()
    },
    selectHandle (date, selectedVal, selectedText) {
      this.date = `${selectedText[0]}年${selectedText[1]}月`
      this.dateValue = `${selectedText[0]}-${selectedText[1]}`
      this.fetchData()
    },
    fetchData () {
      api.record(
        {
          'dateMonth': this.dateValue,
          'userId': this.$route.query.userId,
          'integralType': '1'
        }
      ).then((res) => {
        let { dates, withdrawRecordList } = res.data.content
        let yearList = []
        this.recordList = []
        dates.forEach((item) => {
          let year = item.split('-')[0]
          if (yearList.indexOf(year) < 0) {
            yearList.unshift(year)
          }
        })
        yearList.forEach((item) => {
          let list = withdrawRecordList.filter((ele) => {
            return ele.withdrawDate.indexOf(item) > -1
          })
          this.recordList.push({
            year: item,
            list
          })
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .withdrawncash {
        font-size: 12px;
        text-align: left;
        font-family: PingFangSC-Regular, PingFang SC;
        background: #fff;
        min-width: 100vw;
        min-height: 100vh;
        padding: 15px 20px;
        box-sizing: border-box;
        .search {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 44px;
            background: #F9F9F9;
            border-radius: 7px;
            padding: 0 16px;
            p {
                display: flex;
                height: 44px;
                align-items: center;
                &.date {
                    input {
                        background: transparent;
                        text-align: right;
                        outline: none;
                        border: none;
                    }
                    img {
                        width: 7px;
                        margin-left: 7px;
                    }
                }
            }
            .choose-box {
                display: flex;
                align-items: center;
                .date_icon {
                    width: 14px;
                    height: 14px;
                    margin-right: 3px;
                }
                .choose-date {
                    white-space: nowrap;
                }
            }

        }
        .card_box {
            h3 {
                margin: 15px  0 9px 0;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 20px;
            }
            ul {
                background: #F9F9F9;
                border-radius: 7px;
                padding: 16px 16px 0;
                li {
                    border-bottom: 1px solid #ececec;
                    margin-bottom: 15px;
                }
                li:last-child {
                    border-bottom: none;
                    margin-bottom: 0;
                }
                .withdraw_date {
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 20px;
                    margin-bottom: 7px;
                }
                .flex {
                    display: flex;
                    justify-content: space-between;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 16px;
                    padding-bottom: 14px;
                    .detail {
                        display: flex;
                        align-items: center;
                    }
                    .money {
                        font-size: 9px;
                        font-family: HelveticaNeue-Bold, HelveticaNeue;
                        font-weight: bold;
                        color: #FF7C6D;
                        line-height: 11px;
                    }
                    .red {
                        font-size: 16px;
                        font-family: HelveticaNeue-Bold, HelveticaNeue;
                        font-weight: bold;
                        color: #FF7C6D;
                        line-height: 19px;
                    }
                    .icon {
                        display: inline-block;
                        width: 6px;
                        height: 5px;
                        background: url('../../../assets/image/nsale/arrow_right.png') no-repeat center/6px 5px;
                        margin-left: 7px;
                    }
                }
            }
        }
    }
</style>
